const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Content Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Content', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/learn/v3/content/:subresource', null, {
      find: {params: {subresource: ''}, method: 'GET', isArray: false},
      findMyContent: {params: {subresource: 'my-content'}, method: 'GET', isArray: false},
      approve: {params: {subresource: 'approve'}, method: 'POST', isArray: false},
      disapprove: {params: {subresource: 'disapprove'}, method: 'POST', isArray: false},
      delete: {params: {subresource: 'remove'}, method: 'POST', isArray: false},
      complete: {params: {subresource: 'complete'}, method: 'POST', isArray: false}
    });
  }]);